import React, { useCallback } from "react"

export const withSearchPagination = Component => ({ name = "SearchPagination", currentPage, totalPages, handlePageChange }) => {
  const active = totalPages > 1
  const onPageChange = useCallback((event, page) => {
    handlePageChange(page - 1, event)
    window.scrollTo({ top: 0, left: 0 })
  }, [handlePageChange])

  Component.displayName = name
  return <Component active={active} currentPage={currentPage + 1} handlePageChange={onPageChange} totalPages={totalPages} />
}
